import React from "react";
import { Link } from "react-router-dom";
import { Sprout, Star, Flame, Gem, Crown } from "lucide-react";
import "./LevelBadge.css";

// Five broad tiers across the 1-99 range, purely cosmetic (color/icon) — the
// actual level number always comes from the backend's xpForLevel/levelFromXp
// curve, this just buckets it for a badge color.
export function levelTier(level) {
  const n = level || 1;
  if (n >= 70) return "legend";
  if (n >= 50) return "diamond";
  if (n >= 30) return "gold";
  if (n >= 15) return "silver";
  return "bronze";
}

export const TIER_ICONS = { bronze: Sprout, silver: Star, gold: Flame, diamond: Gem, legend: Crown };

// size: "sm" (avatar overlay, number only) | "md" (inline pill, default) | "lg" (profile header)
// clickable: wraps the badge in a link to the "how XP works" page (default true) —
// pass false only in contexts where a nested link would be invalid (e.g. already inside one).
function LevelBadge({ level, size = "md", showLabel = false, clickable = true }) {
  const lvl = level || 1;
  const tier = levelTier(lvl);
  const Icon = TIER_ICONS[tier];
  const Wrapper = clickable ? Link : "span";
  const wrapperProps = clickable ? { to: "/levels", onClick: (e) => e.stopPropagation(), title: "How levels & XP work" } : {};

  if (size === "sm") {
    return (
      <Wrapper {...wrapperProps} className={`lvl-badge lvl-badge--sm tier-${tier}${clickable ? " lvl-badge--clickable" : ""}`}>
        {lvl}
      </Wrapper>
    );
  }

  return (
    <Wrapper {...wrapperProps} className={`lvl-badge lvl-badge--${size} tier-${tier}${clickable ? " lvl-badge--clickable" : ""}`}>
      <Icon size={size === "lg" ? 15 : 12} strokeWidth={2.4} />
      Lv. {lvl}
      {showLabel && <span className="lvl-badge-tier-label">{tier}</span>}
    </Wrapper>
  );
}

export default LevelBadge;
